export default __webpack_public_path__ + "static/Screenshot8-077597b57b1d3f7fe8b71626707bf891.jpg";